import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import SubmitFeedback from "../../Feedback/Feedback";
import PropTypes from "prop-types"; // ES6

const menuitems = {
  beforedivider: [
    {
      name: "Submit Feedbacks",
      path: ".",
    },
  ],
};

export default function AccountMenu({ anchorEl, handleClose, open }) {
  const [openFeedbackModal, setopenFeedbackModal] = React.useState(false);
  const { beforedivider } = menuitems;

  function goToProfilePage(path, index) {
    if (index === 0) {
      setopenFeedbackModal(true);
    }
  }

  const onCloseModal = () => {
    setopenFeedbackModal(false);
  };

  return (
    <React.Fragment>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {beforedivider.map((menuItem, index) => (
          <MenuItem
            key={index}
            onClick={() => goToProfilePage(menuItem.path, index)}
          >
            <ListItemIcon>
              <WebStoriesIcon fontSize="small" />
            </ListItemIcon>
            {menuItem.name}
          </MenuItem>
        ))}
      </Menu>
      {openFeedbackModal ? (
        <SubmitFeedback
          openFeedBackModal={openFeedbackModal}
          onCloseModal={onCloseModal}
        />
      ) : null}
    </React.Fragment>
  );
}

AccountMenu.propTypes = {
  anchorEl: PropTypes.object,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
};
